import Vue from 'vue'

import {
	LOGIN_SUCCESS,
	LOGIN_FAILED,
	LOGOUT,

	VERIFICATION_SUCCESS,
	VERIFICATION_FAILED,

	FETCH_SUBSCRIPTIONS_SUCCESS,
	FETCH_SUBSCRIPTIONS_FAILED,

	FETCH_PUB_SUBSCRIPTIONS,

	FETCH_QUESTIONS_SUCCESS,
	FETCH_QUESTIONS_FAILED,

	FETCH_PUB_QUESTIONS_SUCCESS,
	FETCH_PUB_QUESTIONS_FAILED,

	SHOW_MODAL,
	HIDE_MODAL,

	SET_QUESTION,

	REGISTER_ACCOUNT_SUCCESS,
	REGISTER_ACCOUNT_FAILURE,

	SET_COMPANY,

	PAY_SUBSCRIPTION_SUCCESS,
	PAY_SUBSCRIPTION_FAILED,

	SHOW_NOTIF,
	CLOSE_NOTIF,
} from '@/store/types'

import {
	COMPANY_LIST,
	PRICE_MONTHLY_COMPANY,
	URL_PREFIX,
} from '@/constants';

import {
	transformSubscriptions,
	successLogin,
	capitalizeFirstLetter,
} from '@/lib/utils'

import {
	stripeHandler,
} from '@/lib/stripe'

export const notification = ({ commit }, data) => {
	commit(SHOW_NOTIF, data)
	setTimeout(() => {
		commit(CLOSE_NOTIF)
	}, data.duration);
}

export const login = async ({ commit }, data) => {
	const { email, password } = data;
	try {
		const response = await fetch(`${URL_PREFIX}/api/auth/login`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', },
			body: JSON.stringify({ email, password })
		})
		const resBody = await response.json();
		if (!response.ok) {
			throw resBody;
		} else {
			commit(LOGIN_SUCCESS, resBody)
			return successLogin(resBody);
		}
	} catch (e) {
		console.log(e);
		commit(LOGIN_FAILED, e.error)
		return false;
	}
}

export const logout = ({ commit }, data) => {
	window.localStorage.clear();
	commit(LOGOUT, {
		userId: null,
		email: '',
		token: ''
	});
}

export const verifyUser = async ({ commit }) => {
	const token = Vue.ls.get('token')
	const userId = Vue.ls.get('userId')
	const email = Vue.ls.get('email')
	if (token !== null && email !== null && userId !== null) {
		commit(VERIFICATION_SUCCESS, { token, userId, email })
		return true;
	} else {
		commit(VERIFICATION_FAILED, 'Verification failed.')
		return false;
	}
}

export const fetchSubscriptions = async ({ commit, state }, loginState) => {
	if (!!loginState) {
		const { userId, token } = state.user.userDetails;
		try {
			const response = await fetch(`${URL_PREFIX}/api/users/${userId}`, {
				headers: {
					'Content-Type': 'application/json',
					'x-access-token': token
				}
			})
			const resBody = await response.json();
			if (!response.ok) {
				throw resBody;
			} else {
				commit(FETCH_SUBSCRIPTIONS_SUCCESS, transformSubscriptions(resBody))
			}
		} catch(e) {
			console.log(e);
			commit(FETCH_SUBSCRIPTIONS_FAILED, e.error)
		}
	} else {
		commit(FETCH_PUB_SUBSCRIPTIONS, COMPANY_LIST);
	}
}

export const fetchCompanyQuestions = async ({ commit, state }, { company }) => {
	const { token } = state.user.userDetails
	const loginState = !!state.user.isLoggedIn
	const userToken = loginState === true ? token : 'skip'
	const FETCH_QUESTIONS_SUCCEEDED = loginState === true ? FETCH_QUESTIONS_SUCCESS : FETCH_PUB_QUESTIONS_SUCCESS
	const FETCH_QUESTIONS_FAILURE = loginState === true ? FETCH_QUESTIONS_SUCCESS : FETCH_PUB_QUESTIONS_SUCCESS
	try {
		const response = await fetch(`${URL_PREFIX}/api/companies/${company}`, {
			headers: {
				'Content-Type': 'application/json',
				'x-access-token': userToken
			}
		})
		const resBody = await response.json();
		if (!response.ok) {
			throw resBody;
		} else {
			commit(FETCH_QUESTIONS_SUCCEEDED, resBody)
		}
	} catch(e) {
		commit(FETCH_QUESTIONS_FAILURE, e.error)
	}
}

export const showModal = ({ commit }, modalName) => {
	commit(SHOW_MODAL, modalName)
}

export const setQuestion = ({ commit }, question) => {
	commit(SET_QUESTION, question)
}

export const hideModal = ({ commit }) => {
	commit(HIDE_MODAL)
}

export const registerAccount = async ({ commit }, { email, password }) => {
	try {
		const response = await fetch(`${URL_PREFIX}/api/auth/register`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', },
			body: JSON.stringify({ email, password })
		})
		const resBody = await response.json();
		if (!response.ok) {
			throw resBody;
		} else {
			commit(REGISTER_ACCOUNT_SUCCESS, resBody)
			return successLogin(resBody);
		}
	} catch (e) {
		console.log('error', e)
		commit(REGISTER_ACCOUNT_FAILURE, e.error);
	}
}

export const setCompany = ({ commit }, company) => {
	commit(SET_COMPANY, capitalizeFirstLetter(company))
}

export const subToCompany = async ({ commit, state }) => {

	const userId = state.user.userDetails.userId;
	const userToken = state.user.userDetails.token;
	const userEmail = state.user.userDetails.email;

	const { stripeKey, company } = state.user;

	const handler = stripeHandler(userEmail, stripeKey)
	const handlerName = 'Tech Interview Club'
	const handlerDescription = `Monthly Subscription for ${company}`
	try {
		handler.open({
			name: handlerName,
			description: handlerDescription,
			amount: PRICE_MONTHLY_COMPANY,
			email: userEmail || null,
			panelLabel: 'Subscription for ',
			allowRememberMe: false,
			token: async (token) => {
				const { id, email } = token
				const response = await fetch(`${URL_PREFIX}/api/stripe/${userId}/subscribe`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Access-Token': userToken,
					},
					body: JSON.stringify({
						stripeToken: id,
						stripeEmail: email,
						company: company.toLowerCase()
					})
				})
				const resBody = await response.json()
				if (!response.ok) {
					throw resBody;
				} else {
					const allCompanies = transformSubscriptions([resBody]);
					commit(PAY_SUBSCRIPTION_SUCCESS, allCompanies)
				}
			}
		})
	}
	catch(e) {
		commit(PAY_SUBSCRIPTION_FAILED, e.error)
	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js